import { makeStyles } from 'tss-react/mui';

import { backdropClasses } from '@mui/material';

export default makeStyles({ name: 'SearchDialogButton' })({
    button: {
        display: 'flex',
        padding: 4,
        alignItems: 'center',
        borderRadius: 8,
        background: '#F8F8F8 !important'
    },
    paper: {
        padding: 8,
        boxSizing: 'border-box',
        scrollbarWidth: 'none',
        background: 'rgba(255, 255, 255, 0.75)',
        backdropFilter: 'blur(calc(var(--base-x40, 16px) / 2))',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    modal: {
        [`.${backdropClasses.root}`]: {
            backgroundColor: 'rgba(255, 255, 255, 0.25)',
            backdropFilter: 'blur(8px)'
        }
    },
    menu: {
        padding: 8,
        boxShadow: '0 8px 16px 0 rgba(176, 178, 186, 0.10), 0 12px 32px 0 rgba(176, 178, 186, 0.25)'
    },
    upgrade: {
        padding: '12px 24px',
        margin: '12px 0'
    },
    searchBar: {
        height: '100%'
    },
    searchBarInput: {
        width: 'auto',
        marginRight: 48
    },
    searchBarList: {
        marginRight: -48,
        overflow: 'auto',
        boxSizing: 'border-box',
        maxHeight: 'calc(100vh - 164px)',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    close: {
        position: 'absolute',
        top: 12,
        right: 8
    }
});
